// Port seam for the desktop dictation bridge (ruling 25): the
// `src/tauri/dictation/**` IPC lives app-side and the `/ui` zone may not reach
// the app, so `src/composition/hosts/dictation/dictation-bridge-wiring.ts` injects it at bootstrap.
// Same shape as the landed hotkey/keyboard/permissions seams —
// fail-loud getter, module-held reference, test reset — but held at the
// package root beside `flags.ts` because the consumers span every ui area
// (widget, bubble, onboarding, anonymous-access) rather than one subtree.
//
// The TYPE lives in `/contracts` (`dictation-bridge.types.ts`); only the
// configure/get pair is a value. Consumers reach it through the root door
// (`@heidi/dictate`), the same door those seams are published through.

import type { DesktopDictationPort } from './contracts/dictation-bridge.types';

let port: DesktopDictationPort | null = null;

export const configureDictationBridgePort = (next: DesktopDictationPort): void => {
  port = next;
};

export const getDictationBridgePort = (): DesktopDictationPort => {
  if (!port) {
    throw new Error(
      '[dictation/bridge-port] port not configured — the app must load ' +
        "'@/composition/hosts/dictation/dictation-bridge-wiring' at bootstrap; tests must call " +
        'configureDictationBridgePort() with a double first.'
    );
  }
  return port;
};

export const resetDictationBridgePortForTests = (): void => {
  port = null;
};
